import OnboardingPartnerConfiguration from "@gamedev-web/partner-onboarding";
import DeveloperStorePartnerConfiguration from "@gamedev-web/partner-developer-store";

import type { AnyPartnerConfiguration } from "@gamedev-web/gamedev-sdk-core";

export const partnerConfigurations: AnyPartnerConfiguration[] = [
  OnboardingPartnerConfiguration,
  DeveloperStorePartnerConfiguration,
].filter(partner => partner && "partnerId" in partner);
